export default globalThis.WebSocket;
